import {
  GetUnreadNotificationsQuery,
  useGetUnreadNotificationsQuery,
} from 'types/generated/client';
import { useViewer } from 'hooks/useViewer';

const POLL_INTERVAL_MS = 30_000;

export type UnreadNotification = GetUnreadNotificationsQuery['userNotifications'][0];

/**
 * Unread count plus the newest unread rows. One caller polls (the app-level toaster);
 * everyone else reads the same Apollo cache entry, so the bell never polls on its own.
 */
export const useUnreadNotifications = ({ isPolling = false } = {}) => {
  const viewer = useViewer();
  const { data } = useGetUnreadNotificationsQuery({
    skip: !viewer.userId,
    variables: { userId: viewer.userId },
    fetchPolicy: isPolling ? 'network-only' : 'cache-first',
    pollInterval: isPolling ? POLL_INTERVAL_MS : 0,
  });

  return {
    unreadCount: data?.userNotificationsAggregate.aggregate?.count ?? 0,
    unread: data?.userNotifications ?? [],
  };
};
